import React from 'react';
import * as SubMenu from './recursive-menu';
import { Link } from 'react-router-dom';

const RecursiveMenu = (data) => {
    data = data.data ? data.data : data;
    const submenu = (data) => {
        return data.map((i, idx) => {
            return (
                    <li className={i.type === 'over-text' ? 'nav-main-heading' : i.type === 'single' ? 'nav-main-link active' : 'nav-main-item'} key={idx}>
                        <Link className={`nav-main-link ${i.children ? 'nav-main-link-submenu' : i.type === 'single' ? 'active' : ''}`}
                            data-toggle={i.children ? 'submenu' : null}
                            aria-haspopup={i.children ? 'true' : null} aria-expanded={i.children ? 'false' : null}
                            to={i.routerLink}
                        >
                            <i className={`nav-main-link-icon ${i.icon ? 'si ' + i.icon : ''}`}></i>
                            <span className="nav-main-link-name">{i.name}</span>
                            {i.badge ? <span className="nav-main-link-badge badge badge-pill badge-success">{i.badge}</span> : ''}
                        </Link>
                        {
                            i.children ?
                                <ul className="nav-main-submenu">
                                    {submenu(i.children)}
                                </ul>
                                :
                                null
                        }
                    </li>
                    )
                })
            };
    return <>{submenu(data)}</>
                    };
                    
export default RecursiveMenu;